<template>
  <vmodal
    :dialog="is_visible"
    :width="795"
    class="board-modal"
    :class="{ 'is-success': is_success }"
    @close="toggle_nexxt_dialog(false)"
  >
    <div v-if="!is_success" slot="title">
      {{ $tr('admin.company.board.search.modal.title') }}
      <img src="/static/images/elements/nexxt-big.png" />
    </div>
    <div id="modal-body" slot="body">
      <div class="close-btn" @click="close">
        <img src="/static/images/elements/close-icon.svg" alt="Close" />
      </div>
      <div v-if="!is_success">
        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.vacancy') }} *
            </div>
            <div class="form-block__content">
              <multiselect
                v-model="selected_vacancy"
                class="big select-vacancy"
                :class="{ 'field-error': has_error('selected_vacancy') }"
                :options="vacancies"
                :show-labels="false"
                :allow-empty="true"
                :searchable="true"
                :is_placeholder_grey="true"
                track-by="id"
                label="name"
                :placeholder="''"
              />
            </div>
          </div>
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.board') }} *
            </div>
            <div class="form-block__content">
              <multiselect
                v-model="selected_board"
                class="big"
                :class="{ 'field-error': has_error('selected_board') }"
                :options="boards"
                :allow-empty="false"
                :is_left="true"
                :multiple="false"
                track-by="id"
                label="name"
                placeholder=""
              />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.keywords') }} *
              <span class="form-block__note">{{
                $tr('admin.company.board.search.modal.separated')
              }}</span>
            </div>
            <div class="form-block__content">
              <multiselect
                v-model="keywords"
                :options="options"
                class="select-tags"
                :class="{ 'field-error': has_error('keywords') }"
                track-by="id"
                name="name"
                :multiple="true"
                label="name"
                :taggable="true"
                :show-labels="false"
                :allow-empty="false"
                :is_textarea="true"
                :is_placeholder_grey="true"
                :placeholder="$tr('admin.company.board.search.modal.eg')"
                @tag="add_keyword"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.location') }} *
            </div>
            <div class="form-block__content">
              <city-select
                :selected-geo="selectedGeo"
                :get-address-data="getAddressData"
                :delete-geo="deleteGeo"
                :is_reload="false"
                :nowrap="true"
                placeholder=""
                lang="en"
                class="settings-company__field"
                :has_error="has_error('selectedGeo')"
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.job_function') }} *
            </div>
            <div class="form-block__content">
              <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'job_functions' }">
                <input
                  v-model="selected_job_functions_names"
                  class="vtfilter-input"
                  type="text"
                  :class="{
                    'field-error': has_error('selected_job_functions')
                  }"
                  placeholder=""
                  readonly
                  @click.stop="set_show_filter('job_functions')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'job_functions'"
                ref="filter_job_functions"
                class="th_filter"
                :type="'list'"
                lang="en"
                :list="job_functions"
                :selected_list="selected_job_functions"
                :input_placeholder="
                  $tr('admin.company.board.search.modal.placeholder.job_functions', 'en')
                "
                :wrapper_selector="'.v-dialog-card'"
                :filter_name="'job_functions'"
                @input="set_selected_job_functions"
                @apply="apply_filter('job_functions')"
                @cancel="cancel_filter"
                @clear="clear_filter('job_functions')"
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.employment') }} *
            </div>
            <div class="form-block__content">
              <div
                class="vtfilter-input-wrap"
                :class="{ opened: show_filter === 'employment_types' }"
              >
                <input
                  v-model="selected_employment_names"
                  class="vtfilter-input"
                  type="text"
                  placeholder=""
                  :class="{ 'field-error': has_error('selected_employment') }"
                  readonly
                  @click.stop="set_show_filter('employment_types')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'employment_types'"
                ref="filter_employment_types"
                class="th_filter right"
                :type="'list'"
                lang="en"
                :list="employment_types"
                :selected_list="selected_employment"
                :input_placeholder="
                  $tr('admin.company.board.search.modal.placeholder.employment_types', 'en')
                "
                :wrapper_selector="'.v-dialog-card'"
                :filter_name="'employment_types'"
                @input="set_selected_employment"
                @apply="apply_filter('employment_types')"
                @cancel="cancel_filter"
                @clear="clear_filter('employment_types')"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.education') }} *
            </div>
            <div class="form-block__content">
              <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'education' }">
                <input
                  v-model="selected_education_names"
                  class="vtfilter-input"
                  type="text"
                  placeholder=""
                  :class="{
                    'field-error': has_error('selected_education_level')
                  }"
                  readonly
                  @click.stop="set_show_filter('education')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'education'"
                ref="filter_education"
                lang="en"
                class="th_filter"
                :type="'list'"
                :list="education_levels"
                :selected_list="selected_education_level"
                :input_placeholder="
                  $tr('admin.company.board.search.modal.placeholder.education_levels', 'en')
                "
                :wrapper_selector="'.v-dialog-card'"
                :filter_name="'education'"
                @input="set_selected_education"
                @apply="apply_filter('education')"
                @cancel="cancel_filter"
                @clear="clear_filter('education')"
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.relocation') }} *
            </div>
            <div class="form-block__content">
              <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'relocation' }">
                <input
                  v-model="selected_relocation_names"
                  class="vtfilter-input"
                  type="text"
                  placeholder=""
                  :class="{ 'field-error': has_error('selected_relocation') }"
                  readonly
                  @click.stop="set_show_filter('relocation')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'relocation'"
                ref="filter_relocation"
                lang="en"
                class="th_filter"
                :type="'list'"
                :list="relocation_preferences"
                :selected_list="selected_relocation"
                :input_placeholder="
                  $tr('admin.company.board.search.modal.placeholder.relocation', 'en')
                "
                :wrapper_selector="'.v-dialog-card'"
                :filter_name="'relocation'"
                @input="set_selected_relocation"
                @apply="apply_filter('relocation')"
                @cancel="cancel_filter"
                @clear="clear_filter('relocation')"
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.citizenship') }} *
            </div>
            <div class="form-block__content">
              <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'citizenship' }">
                <input
                  v-model="selected_citizenship_names"
                  class="vtfilter-input"
                  type="text"
                  placeholder=""
                  :class="{
                    'field-error': has_error('selected_citizenship_types')
                  }"
                  readonly
                  @click.stop="set_show_filter('citizenship')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'citizenship'"
                ref="filter_citizenship"
                class="th_filter right"
                lang="en"
                :type="'list'"
                :list="citizenship_types"
                :selected_list="selected_citizenship_types"
                :input_placeholder="
                  $tr('admin.company.board.search.modal.placeholder.citizenship_types', 'en')
                "
                :wrapper_selector="'.v-dialog-card'"
                :filter_name="'citizenship'"
                @input="set_selected_citizenship_types"
                @apply="apply_filter('citizenship')"
                @cancel="cancel_filter"
                @clear="clear_filter('citizenship')"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.experience') }} *
              <span class="form-block__note">{{
                $tr('admin.company.board.search.modal.years')
              }}</span>
            </div>
            <div class="form-block__content">
              <vslider
                :is_range="true"
                :value="experience_value"
                :labels="ticksLabels"
                step="1"
                :min="0"
                :max="7"
                ticks="always"
                size="8"
                @set_value="set_value"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.salary') }} *
              <span class="form-block__note">($)</span>
            </div>
            <div class="form-block__content">
              <vslider
                v-model="salary_value"
                :is_range="true"
                :labels="salary_labels"
                step="1"
                :min="0"
                :max="9"
                ticks="always"
                size="10"
                @set_value="set_salary_value"
              />
            </div>
          </div>
        </div>

        <div class="form-row form-row__align-end">
          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.number_of_cv') }} *
            </div>
            <div class="form-block__content">
              <input
                ref="input_per_request"
                v-model="max_items_per_request"
                class="big"
                :class="{ 'field-error': has_error('max_items_per_request') }"
                min="1"
                max="100"
                type="number"
                :placeholder="$tr('admin.company.board.search.modal.number_of_cv_range')"
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.number_of_searches') }} *
            </div>
            <div class="form-block__content">
              <multiselect
                v-model="selected_requests_per_day"
                class="big"
                :class="{
                  'field-error': has_error('selected_requests_per_day')
                }"
                :options="requests_per_days"
                :show-labels="false"
                :allow-empty="true"
                :searchable="true"
                track-by="id"
                label="name"
                placeholder=""
              />
            </div>
          </div>

          <div class="form-block">
            <div class="form-block__label">
              {{ $tr('admin.company.board.search.modal.period') }} *
            </div>
            <div class="form-block__content">
              <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'date' }">
                <input
                  v-model="selected_dates_names"
                  class="vtfilter-input"
                  type="text"
                  placeholder="DD.MM.YY - DD.MM.YY"
                  :class="{ 'field-error': has_error('filter_dates') }"
                  readonly
                  @click.stop="set_show_filter('date')"
                />
                <img src="/static/icons/drop_arrow.svg" />
              </div>
              <vtfilter
                v-if="show_filter === 'date'"
                class="th_filter th_filter_bottom"
                lang="en"
                :type="'date'"
                :dates="filter_dates"
                :wrapper_selector="'.v-dialog-card'"
                :is_days_disabled_start="false"
                @input="set_filter_dates"
                @apply="apply_filter('dates')"
                @cancel="cancel_filter"
                @clear="date_clear"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="success-modal">
        <img src="/static/images/elements/icon_big_ok.png" />
        <div class="success-desc">
          A new search has been successfully created. Suitable candidates will appear on the
          <router-link :to="{ name: 'admin-company-import-seekers' }">Job seekers</router-link>
          tab, from where you can invite them to a videointerview.
        </div>
        <vbutton label="common.ok" @click="submit" />
      </div>
    </div>
    <div v-if="!is_success" slot="footer">
      <div class="board-footer-block">
        <vbutton
          label="admin.company.board.search.modal.search"
          :disabled="loading"
          @click="create_filter"
        />

        <div class="filter_clear_wrapper" @click="all_filters_clear">
          <div class="filter_clear"></div>
        </div>
        <span v-if="error_fields.length" class="error-text">All fields are required.</span>
      </div>
    </div>
  </vmodal>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  import CitySelect from './city_select.vue';
  import { get_address } from '@/_helpers/utils';
  import { STORE_PREFIX } from '../../../constants.js';
  import { mapGetters } from 'vuex';

  export default {
    name: 'BoardModal',

    components: {
      CitySelect
    },

    props: {
      is_visible: Boolean,
      citizenship_types: Array,
      education_levels: Array,
      employment_types: Array,
      relocation_preferences: Array,
      job_functions: Array,
      companyId: String,
      vacancy_id_default: [Number],
      model: Object
    },

    data() {
      return {
        keywords: [],
        options: [],
        value: 0,
        experience_value: [0, 7],
        salary_value: [0, 9],
        items_per_request: null,
        selected_location: [],
        selected_education_level: [],
        selected_relocation: [],
        selected_employment: [],
        selected_job_functions: [],
        selected_citizenship_types: [],
        selectedGeo: {},
        filter_dates: [],
        selected_vacancy: null,
        show_filter: 'none',
        is_success: false,
        loading: false,
        selected_requests_per_day: {
          id: 1,
          name: 'Once a day'
        },

        error_fields: [],
        filter_id: null,
        selected_board: {
          id: 1,
          name: 'Nexxt'
        },

        boards: [
          {
            id: 1,
            name: 'Nexxt'
          }
        ],

        ticksLabels: ['0', '1', '3', '5', '10', '15', '20', '20+'],
        salary_labels: ['0', '20', '40', '60', '80', '100', '120', '140', '200', '250+'],

        form_fields: [
          'selected_vacancy',
          'selected_board',
          'keywords',
          'selectedGeo',
          'selected_job_functions',
          'selected_employment',
          'selected_education_level',
          'selected_relocation',
          'selected_citizenship_types',
          'max_items_per_request',
          'selected_requests_per_day',
          'filter_dates'
        ],

        requests_per_days: [
          {
            id: 1,
            name: 'Once a day'
          },
          {
            id: 2,
            name: 'Twice a day'
          }
        ]
      };
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        vacancies: 'vacancies/list'
      }),

      max_items_per_request: {
        get() {
          return this.items_per_request;
        },

        set(val) {
          if (val > 100) {
            val = 100;
          } else if (val < 1) {
            val = 1;
          }
          this.items_per_request = val;
          if (this.$refs.input_per_request) {
            this.$refs.input_per_request.value = val;
          }
        }
      },

      vacancy_id() {
        if (this.vacancy_id_default) {
          return this.vacancy_id_default;
        }

        if (!this.selected_vacancy || !this.selected_vacancy.id) {
          return null;
        }

        return this.selected_vacancy.id;
      },

      selected_education_names() {
        if (
          !this.selected_education_level ||
          !this.selected_education_level.length ||
          !this.education_levels ||
          !this.education_levels.length
        ) {
          return '';
        }

        let row = '';

        this.selected_education_level.forEach((item, index) => {
          const education = this.education_levels.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${education ? education.name : ''}`;
          } else {
            row += `${education ? education.name : ''}`;
          }
        });

        return row;
      },

      selected_relocation_names() {
        if (
          !this.selected_relocation ||
          !this.selected_relocation.length ||
          !this.relocation_preferences ||
          !this.relocation_preferences.length
        ) {
          return '';
        }

        let row = '';

        this.selected_relocation.forEach((item, index) => {
          const relocation = this.relocation_preferences.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${relocation ? relocation.name : ''}`;
          } else {
            row += `${relocation ? relocation.name : ''}`;
          }
        });

        return row;
      },

      selected_employment_names() {
        if (
          !this.selected_employment ||
          !this.selected_employment.length ||
          !this.employment_types ||
          !this.employment_types.length
        ) {
          return '';
        }

        let row = '';

        this.selected_employment.forEach((item, index) => {
          const employment = this.employment_types.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${employment ? employment.name : ''}`;
          } else {
            row += `${employment ? employment.name : ''}`;
          }
        });

        return row;
      },

      selected_citizenship_names() {
        if (
          !this.selected_citizenship_types ||
          !this.selected_citizenship_types.length ||
          !this.citizenship_types ||
          !this.citizenship_types.length
        ) {
          return '';
        }

        let row = '';

        this.selected_citizenship_types.forEach((item, index) => {
          const employment = this.citizenship_types.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${employment ? employment.name : ''}`;
          } else {
            row += `${employment ? employment.name : ''}`;
          }
        });

        return row;
      },

      selected_job_functions_names() {
        if (
          !this.selected_job_functions ||
          !this.selected_job_functions.length ||
          !this.job_functions ||
          !this.job_functions.length
        ) {
          return '';
        }

        let row = '';

        this.selected_job_functions.forEach((item, index) => {
          const employment = this.job_functions.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${employment ? employment.name : ''}`;
          } else {
            row += `${employment ? employment.name : ''}`;
          }
        });

        return row;
      },

      selected_dates_names() {
        if (!this.filter_dates || !this.filter_dates.length) {
          return '';
        }

        let row = '';

        this.filter_dates.forEach((item, index) => {
          if (index !== 0) {
            row += ` - ${item}`;
          } else {
            row += `${item}`;
          }
        });

        return row;
      }
    },

    watch: {
      selected_board(val) {
        if (!val) {
          this.selected_board = {
            id: 1,
            name: 'nexxt'
          };
        }
      }
    },

    created() {
      if (this.model) {
        const filter_id = this.model.filter_id;
        this.filter_id = filter_id;
        axios.get(`/v2/boards/filters/${filter_id}`).then(response => {
          const dates = [this.model.start_at, this.model.finish_at];
          this.filter_dates.splice(0, this.filter_dates.length, ...dates);
          const filter_response = response.data;

          this.set_selected_education(filter_response.education_level);
          this.set_selected_employment(filter_response.employment_type);
          this.set_selected_job_functions(filter_response.job_function);
          this.set_selected_relocation(filter_response.relocation);
          this.set_selected_citizenship_types(filter_response.citizenship);

          if (this.model) {
            this.set_selected_vacancy(this.model.vacancy_id);
          }

          if (filter_response.keywords && filter_response.keywords.length) {
            let keywords = [];
            filter_response.keywords.forEach(keyword => {
              keywords.push({
                id: keywords.length,
                name: keyword
              });
            });

            this.keywords.splice(0, 0, ...keywords);
          }

          this.set_sliders(filter_response);

          if (filter_response.location && filter_response.options) {
            this.selectedGeo = {
              description: filter_response.location,
              place_id: filter_response.options.place_id
            };
          }

          const filter_dates_default = [
            this.get_date(this.model.start_at),
            this.get_date(this.model.finish_at)
          ];
          this.set_filter_dates(filter_dates_default);

          this.max_items_per_request = this.model.max_items_per_request;
          this.requests_per_day =
            this.requests_per_days.find(req => +req.id === +this.model.request_per_day) || 1;

          if (this.model.request_per_day) {
            this.requests_per_days.forEach(req => {
              if (req.id === this.model.request_per_day) {
                this.selected_requests_per_day = req;
              }
            });
          }
        });
      }
    },

    beforeDestroy() {
      this.is_success = false;
      this.cancel_filter();
    },

    methods: {
      set_selected_location(model) {
        this.selected_location = model.result || model;
      },

      set_selected_education(model) {
        this.selected_education_level = model.result || model;
      },

      set_selected_relocation(model) {
        this.selected_relocation = model.result || model;
      },

      set_selected_employment(model) {
        this.selected_employment = model.result || model;
      },

      set_selected_citizenship_types(model) {
        this.selected_citizenship_types = model.result || model;
      },

      set_selected_job_functions(model) {
        this.selected_job_functions = model.result || model;
      },

      has_error(field) {
        return !!this.error_fields.find(error_field => error_field === field);
      },

      get_date(date) {
        if (!date) {
          return '';
        }
        return moment.unix(date).format('YYYY-MM-DD') || '';
      },

      close() {
        this.$emit('close');
      },

      set_filter_dates(model) {
        this.filter_dates = model.result || model;
      },

      clear_filter(filter) {
        switch (filter) {
          case 'education':
            this.set_selected_education(
              this.model ? { result: this.model.education_level } : { result: [] }
            );
            break;
          case 'job_functions':
            this.set_selected_job_functions(
              this.model ? { result: this.model.job_function } : { result: { result: [] } }
            );
            break;
          case 'employment_types':
            this.set_selected_employment(
              this.model ? { result: this.model.employment_type } : { result: [] }
            );
            break;
          case 'relocation':
            this.set_selected_relocation(
              this.model ? { result: this.model.relocation } : { result: [] }
            );
            break;
          case 'citizenship':
            this.set_selected_citizenship_types(
              this.model ? { result: this.model.citizenship } : { result: [] }
            );
            break;
          default:
            break;
        }
        // this.cancel_filter();
      },

      getAddressData(addressData, placeResultData) {
        this.selectedGeo = get_address(addressData, placeResultData);
      },

      deleteGeo() {
        this.selectedGeo = {
          place_id: null,
          description: null
        };
      },

      set_sliders(data) {
        let experience_arr = [];
        let salary_arr = [];

        if (!data.min_experience) {
          experience_arr[0] = 0;
        }
        if (data.min_experience >= 20) {
          experience_arr[0] = this.ticksLabels.length - 1;
        }
        if (!data.max_experience) {
          experience_arr[1] = this.ticksLabels.length - 1;
        }
        if (data.max_experience >= 20) {
          experience_arr[1] = this.ticksLabels.length - 1;
        }
        this.ticksLabels.forEach((label, index) => {
          if ('' + label === '' + data.min_experience) {
            if (experience_arr[0] === undefined) {
              experience_arr[0] = index;
            }
          }
          if ('' + label === '' + data.max_experience) {
            if (experience_arr[1] === undefined) {
              experience_arr[1] = index;
            }
          }
        });

        if (!data.min_salary) {
          salary_arr[0] = 0;
        }
        if (data.min_salary >= 250000) {
          salary_arr[0] = this.salary_labels.length - 1;
        }
        if (!data.max_salary) {
          salary_arr[1] = this.salary_labels.length - 1;
        }
        if (data.max_salary >= 250000) {
          salary_arr[1] = this.salary_labels.length - 1;
        }
        this.salary_labels.forEach((label, index) => {
          if ('' + label + '000' === '' + data.min_salary) {
            if (salary_arr[0] === undefined) {
              salary_arr[0] = index;
            }
          }
          if ('' + label + '000' === '' + data.max_salary) {
            if (salary_arr[1] === undefined) {
              salary_arr[1] = index;
            }
          }
        });

        this.experience_value.splice(0, 0, ...experience_arr);
        this.salary_value.splice(0, 0, ...salary_arr);
      },

      apply_filter(filter) {
        this.cancel_filter();
      },

      cancel_filter() {
        this.set_show_filter('none');
      },

      vacancy_clear() {
        this.keywords = [];
      },

      set_show_filter(v) {
        this.show_filter = v;
        if (v !== 'date') {
          setTimeout(() => {
            if (this.$refs[`filter_${v}`] && this.$refs[`filter_${v}`].$refs.vfilter_input) {
              this.$refs[`filter_${v}`].$refs.vfilter_input.$refs.input.focus();
            }
          }, 100);
        }
      },

      date_clear(type) {
        this.set_filter_dates(
          this.model ? [this.model.start_at || '', this.model.finish_at || ''] : []
        );
        this.cancel_filter();
      },

      get_modified_slider_array(arr, max_value) {
        let salary_array = [];
        if (arr[0] === max_value) {
          salary_array = [max_value, null];
        } else if (arr[0] !== max_value && arr[1] === max_value) {
          salary_array = [arr[0], null];
        } else {
          salary_array = arr;
        }

        return salary_array;
      },

      set_selected_vacancy(id) {
        if (!this.vacancies || !this.vacancies.length) {
          return;
        }

        const vacancy = this.vacancies.find(vac => +vac.id === id);
        if (vacancy) {
          this.selected_vacancy = vacancy;
        }
      },

      set_value(val) {
        this.experience_value = val;
      },

      set_salary_value(val) {
        this.salary_value = val;
      },

      add_keyword(val) {
        if (!val) {
          return;
        }
        const values_array = val.split(',');
        if (values_array.length) {
          values_array.forEach(value => {
            this.keywords.push({
              id: this.keywords.length,
              name: value.trim()
            });
          });
        } else {
          this.keywords.push({
            id: this.keywords.length,
            name: val.trim()
          });
        }
      },

      toggle_nexxt_dialog(val) {
        this.$emit('toggle_nexxt_dialog', val);
      },

      all_filters_clear() {
        this.keywords = [];
        this.options = [];
        this.value = 0;
        this.experience_value = [0, 0];
        this.salary_value = [0, 0];
        this.items_per_request = null;
        this.selected_location = [];
        this.selected_education_level = [];
        this.selected_relocation = [];
        this.selected_employment = [];
        this.selected_job_functions = [];
        this.selected_citizenship_types = [];
        this.selectedGeo = {};
        this.filter_dates = [];
        this.selected_vacancy = null;
        this.show_filter = 'none';
        this.is_success = false;
        this.selected_requests_per_day = {
          id: 1,
          name: 'Once a day'
        };
      },

      create_filter() {
        this.error_fields = [];
        this.form_fields.forEach(field => {
          const value = Array.isArray(this[field]) ? !!this[field].length : !!this[field];
          if (!value) {
            this.error_fields.push(field);
          }
          if (field === 'selectedGeo' && this[field] && !this[field].place_id) {
            this.error_fields.push(field);
          }
        });
        if (this.error_fields && this.error_fields.length) {
          return;
        }
        const active_within_days = 30;
        let min_experience = this.ticksLabels[this.experience_value[0]];
        if (min_experience === '20+') {
          min_experience = 20;
        }
        let max_experience = this.ticksLabels[this.experience_value[1]];
        if (max_experience === '20+') {
          max_experience = 20;
        }
        const experience_values = this.get_modified_slider_array(
          [min_experience, max_experience],
          20
        );
        let min_salary = this.salary_labels[this.salary_value[0]];
        if (min_salary === '250+') {
          min_salary = 250;
        }
        let max_salary = this.salary_labels[this.salary_value[1]];
        if (max_salary === '250+') {
          max_salary = 250;
        }
        const salary_values = this.get_modified_slider_array([min_salary, max_salary], 250);
        this.loading = true;
        if (this.filter_id) {
          axios
            .put(`/v2/boards/filters/${this.filter_id}`, {
              keywords: this.keywords.map(item => item.name),
              education_level: this.selected_education_level,
              employment_type: this.selected_employment,
              citizenship: this.selected_citizenship_types,
              relocation: this.selected_relocation,
              job_function: this.selected_job_functions,
              location: this.selectedGeo ? this.selectedGeo.description : '',
              options: this.selectedGeo ? { place_id: this.selectedGeo.place_id } : null,
              min_experience:
                experience_values[0] === null || experience_values[0] === '0'
                  ? null
                  : experience_values[0],
              max_experience:
                experience_values[1] === null || experience_values[1] === '0'
                  ? null
                  : experience_values[1],
              min_salary:
                salary_values[0] === null || salary_values[0] === '0'
                  ? null
                  : salary_values[0] + '000' || '0',
              max_salary:
                salary_values[1] === null || salary_values[1] === '0'
                  ? null
                  : salary_values[1] + '000' || '0',
              active_within_days: active_within_days
            })
            .then(response => {
              this.create_task(response.data.id);
            })
            .catch(err => {
              this.$noty.error('common.error');
              this.loading = false;
            });
        } else {
          axios
            .post('/v2/boards/filters', {
              keywords: this.keywords.map(item => item.name),
              education_level: this.selected_education_level,
              employment_type: this.selected_employment,
              citizenship: this.selected_citizenship_types,
              relocation: this.selected_relocation,
              job_function: this.selected_job_functions,
              location: this.selectedGeo ? this.selectedGeo.description : '',
              options: this.selectedGeo ? { place_id: this.selectedGeo.place_id } : null,
              min_experience:
                experience_values[0] === null || experience_values[0] === '0'
                  ? null
                  : experience_values[0],
              max_experience:
                experience_values[1] === null || experience_values[1] === '0'
                  ? null
                  : experience_values[1],
              min_salary:
                salary_values[0] === null || salary_values[0] === '0'
                  ? null
                  : salary_values[0] + '000' || '0',
              max_salary:
                salary_values[1] === null || salary_values[1] === '0'
                  ? null
                  : salary_values[1] + '000' || '0',
              active_within_days: active_within_days
            })
            .then(response => {
              this.create_task(response.data.id);
            })
            .catch(err => {
              this.$noty.error('common.error');
              this.loading = false;
            });
        }
      },

      create_task(filter_id) {
        if (this.model) {
          axios
            .put(`/v2/boards/tasks/${this.model.id}`, {
              board_id: 1,
              vacancy_id: this.vacancy_id,
              company_id: this.companyId,
              filter_id,
              start_at: this.filter_dates[0],
              finish_at: this.filter_dates[1],
              request_per_day: this.selected_requests_per_day
                ? this.selected_requests_per_day.id
                : 1,
              max_items_per_request: this.max_items_per_request
            })
            .then(response => {
              this.$emit('update');
              this.is_success = true;
              this.loading = false;
            })
            .catch(err => {
              this.$noty.error(this.$tr('common.error'));
              this.loading = false;
            });
        } else {
          axios
            .post('/v2/boards/tasks', {
              board_id: 1,
              vacancy_id: this.vacancy_id,
              company_id: this.companyId,
              filter_id,
              start_at: this.filter_dates[0],
              finish_at: this.filter_dates[1],
              request_per_day: this.selected_requests_per_day
                ? this.selected_requests_per_day.id
                : 1,
              max_items_per_request: this.max_items_per_request
            })
            .then(response => {
              this.$emit('update');
              this.is_success = true;
              this.loading = false;
            })
            .catch(err => {
              this.$noty.error(this.$tr('common.error'));
              this.loading = false;
            });
        }
      },

      submit() {
        this.$emit('submit');
      }
    }
  };
</script>

<style lang="scss">
  .board-modal {
    position: relative;

    .th_filter {
      position: absolute;
      left: 0;
      top: 45px;
      &.right {
        right: 0;
        left: auto;
      }

      &.th_filter_bottom {
        left: -315px;
        top: auto;
        bottom: 0;
      }
    }

    .form-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 22px;

      &.form-row__align-end {
        align-items: flex-end;
      }
    }

    .form-block {
      flex: 1;

      &:not(:first-child) {
        margin-left: 40px;
      }
    }

    .form-block__label {
      margin-bottom: 14px;
      // font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 15px;
      line-height: 22px;
      letter-spacing: 0.005em;
      color: #233346;
    }

    .form-block__note {
      color: #9faab6;
    }

    .form-block__content {
      position: relative;
    }

    .vtfilter-input-wrap {
      position: relative;

      img {
        position: absolute;
        top: 17px;
        right: 11px;
        transform: rotate(180deg);
        cursor: pointer;
      }

      &.opened {
        img {
          transform: rotate(0deg);
        }
      }
    }

    .filter_clear_wrapper {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f4f5f7;
      border-radius: 2px;
      margin-left: 20px;
      cursor: pointer;
    }

    .filter_clear {
      min-height: 16px;
      max-height: 16px;
      max-width: 16px;
      min-width: 16px;
      background: url(/static/icons/clear_filter.svg) center no-repeat;
      background-size: 18px 18px;
      cursor: pointer;
    }

    .vtfilter-input {
      width: 100%;
      padding-right: 22px;
      cursor: pointer;

      &[readonly] {
        color: #232323;
      }
    }

    .settings-company__field {
      width: 100%;
      max-width: 200px;

      .multiselect {
        width: 100%;
        max-width: 100% !important;
      }
    }

    .multiselect.big {
      &.select-vacancy {
        width: 440px;
        max-width: 100%;
      }
    }

    .form-block {
      input {
        width: 100%;
      }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type='number'] {
      -moz-appearance: textfield; /* Firefox */
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0;
    }

    .success-modal {
      display: flex;
      flex-direction: column;
      align-items: center;

      div {
        margin: 32px auto 34px;
        width: 380px;
        text-align: center;
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.005em;
        color: #233346;
      }
    }

    &.is-success {
      .v-dialog {
        width: 620px !important;
        height: auto !important;
      }
    }

    .field-error {
      border-color: #f65046 !important;
    }

    .error-text {
      position: absolute;
      left: 0;
      bottom: -23px;
      // font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 19px;
      letter-spacing: 0.005em;
      color: #f65046;
    }

    .board-footer-block {
      position: relative;
      display: flex;
      align-items: center;
    }

    .close-btn {
      position: absolute;
      top: 25px;
      right: 25px;
      width: 15.5px;
      height: 15.5px;
      cursor: pointer;

      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>
